import { render } from "./QModalDemo.vue?vue&type=template&id=785c3ce5&scoped=true"
const script = {}

import "./QModalDemo.vue?vue&type=style&index=0&id=785c3ce5&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785c3ce5"]])

export default __exports__